<template>
  <div class="yanxuan-h5-container">
    <img
      src="../assets/image/xdyxopen/bg@2x.png"
      alt=""
      class="yanxuan-h5-bg"
    />
    <div id="loadDownBtn" class="yanxuan-h5-download-btn-box">
      <div class="yanxuan-h5-download-btn" @click="openApp()">
        <span class="yanxuan-h5-download-btn-text">立即下载小当严选APP</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      logo: require('@/assets/image/xdyxopen/bg@2x.png')
    }
  },
  computed: {},
  mounted() {},
  methods: {
    openApp() {
      const url = window.location.href
      const params = this.getUrlParams(url)
      const page = params.page
      const id = params.id
      console.log(page)
      console.log(id)
      // iOS App的Scheme和App Store链接
      const iOSAppScheme = 'xdyx'
      const iOSAppStoreUrl = 'https://itunes.apple.com/app/id1528525091'
      // Android App的Scheme和下载链接
      const androidAppScheme = 'xdyxapp'
      const androidDownloadUrl =
        'https://yihuandl.oppo.com/default/20240116/035322_1747165129025392640_1705391601815.apk'
      // 检测设备类型
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      // 如果是iOS设备
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        // 尝试打开iOS App的Scheme
        window.location.href = iOSAppScheme + '://'
        // 延迟一段时间后，如果还在当前页面，则跳转到App Store
        setTimeout(function () {
          window.location.href = iOSAppStoreUrl
        }, 1000) // 这里的1000表示1秒，您可以根据实际情况调整超时时间
      } else if (/android/i.test(userAgent)) {
        // 尝试打开Android App的Scheme
        window.location.href =
          androidAppScheme + `://xdyx.app/openwith?page=${page}&id=${id}`
        // 延迟一段时间后，如果还在当前页面，则通过链接下载
        setTimeout(function () {
          window.location.href = androidDownloadUrl
        }, 3000) // 这里的1000表示1秒，您可以根据实际情况调整超时时间
      }
    },
    getUrlParams(url) {
      const params = {}
      const queryString = url.split('?')[1]

      if (!queryString) {
        return params
      }

      const paramPairs = queryString.split('&')

      for (const pair of paramPairs) {
        const [key, value] = pair.split('=')
        params[key] = decodeURIComponent(value)
      }

      return params
    }
  }
}
</script>

<style scoped>
img {
  display: block;
}
.yanxuan-h5-container {
  width: 100%;
  margin: 0 auto;
  background: #380b2e;
  padding-bottom: 100px;
}
.yanxuan-h5-bg {
  width: 100%;
  margin: 0 auto;
}
.yanxuan-h5-download-btn-box {
  width: 100%;
  /* max-width: 480px; */
  padding: 15px 28px;
  position: fixed;
  bottom: 0;
  background: #fff;
  box-sizing: border-box;
}
.yanxuan-h5-download-btn {
  height: 100px;
  background: #ff4d00;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.yanxuan-h5-download-btn-text {
  font-size: 32px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 22px;
}
</style>
